// Placeholder values — replace via .env.local until backend confirms real ones.
// See .env.example for the variable names to set.
export const API_BASE_URL =
  process.env.REACT_APP_SSO_API_BASE_URL ;
export const CLIENT_ID = process.env.REACT_APP_SSO_CLIENT_ID;
export const REDIRECT_URI =
  process.env.REACT_APP_SSO_REDIRECT_URI || `${window.location.origin}/callback`;

export const brandConfig = Object.freeze({
  appName: "Kriha Garment OS",
  workspaceName: "Kriha Garment OS",
});

// Sign-in methods offered on the "/" landing page (same mechanism as lms-kriha-frontend).
// Only "sso" has backend support today; "password", "otp" and self-signup call the
// /v1/auth/* contract (see auth/authApi.js) and start working once the Garment backend ships it.
// Exactly one method here skips the chooser and lands straight on that method's page.
export const loginConfig = Object.freeze({
  // "otp" commented out for now - add it back to re-enable the email + one-time code flow.
  methods: ["sso", "password" /* , "otp" */],
  // Create-account flow commented out for now - set back to true to re-enable.
  selfSignup: false,
});

export const loginMethodPath = Object.freeze({
  sso: "/login/sso",
  password: "/login/password",
  otp: "/login/otp",
});

export const isLoginMethodEnabled = (method) => loginConfig.methods.includes(method);

// Deploy-time kill switch for self-signup; both this and loginConfig.selfSignup must be true.
export const SELF_SIGNUP_ENABLED = process.env.REACT_APP_SELF_SIGNUP_ENABLED !== "false";

// Only local sign-ins (brand / manufacturer password login) set authMethod; the SSO callback never
// does. Local sessions have no refresh token and nothing server-side to end on logout.
export const isLocalAuthSession = (auth) => !!auth?.authMethod;
